import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

interface SuppliesRequest {
    category: string;
    limit: string;
    page: number;
}
export type DataListProps = {
    list_no: number;
    name: string;
    subject: string;
    status: string;
    w_date: string;
};

export interface SuppliesResponseData {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: DataListProps[];
}

export const useGetConsoleSupplies = ({ category, page, limit }: SuppliesRequest): UseQueryResult<SuppliesResponseData, Error> => {
    let url = enum_api_uri.get_console_supplies.replace(":category", category);
    return useQuery({
        queryKey: ["useGetConsoleSupplies", category, page, limit],
        queryFn: async () => {
            const response = await axiosInstance.get(url, {
                params: {
                    page,
                    limit,
                },
            });
            return response.data.data;
        },
    });
};
